import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './commonjs/fontSize';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import UserAgreementPage from './component/agreementpage';
import HelpPage from './component/helppage';
import VipServicePage from './component/vipservicepage';
import PrivacyPage from './component/privacypage';
import NewEraPrivacy from './component/newEra/newEraPrivacy';
import UserServiceAgreement from './component/newEra/userServiceAgreement';
import HealthPrivacy from './component/healthChina/healthPrivacy';
import HealthUserAgreement from './component/healthChina/healthUserAgreement';
import YnPrivacy from './component/ynPrivacy/ynPrivacy';
import Agreement from './component/agreement';
import HomePage from './component/homepage'


const MainPage = () => {
    return <Router>
        <div>
            <Route exact path="/" component={HomePage}></Route>
            <Route exact path="/user" component={UserAgreementPage} ></Route>
            <Route exact path="/help" component={HelpPage}></Route>
            <Route exact path="/privacy" component={PrivacyPage}></Route>
            <Route exact path="/vip" component={VipServicePage}></Route>
            <Route exact path="/newEraPrivacy" component={NewEraPrivacy}></Route>
            <Route exact path="/userServiceAgreement" component={UserServiceAgreement}></Route>
            <Route exact path="/healthPrivacy" component={HealthPrivacy}></Route>
            <Route exact path="/healthUserAgreement" component={HealthUserAgreement}></Route>
            <Route exact path="/ynPrivacy" component={YnPrivacy}></Route>
            <Route exact path="/agreement" component={Agreement}></Route>
        </div>
    </Router>
};

ReactDOM.render(<MainPage />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js